<template>
<div id="template_72">
   <div id="main-container" data-channel="media-gallery-video-wall">
      <!-- *** Insert recid for this instance in the data-instance attribute *** -->
      <div id="main-wrapper" data-instance="897">
         <div	id="video-container">
            <div class="video-wrapper" data-zone="zone-03">
               <!-- if the user uploaded a custom thumbnail, use that in place of the thumbnail image -->

               <video data-recid="909" autoplay preload="auto" id="video" name="media" :src="this.GALLERY_HOST + '/' + zone1.val" type="video/mp4"></video>
            </div>
         </div>

         <div id="text-container">
            <div class="text-wrapper" data-zone="zone-02">
               <div class="description">
                  <span>{{zone2.val}}</span>
               </div>
               <!-- <div class="credit">
                  <span>I am the credits. Quisque pellentesque. </span>
               </div> -->
            </div>
         </div>
         
         <div id="branding-container">
            <div class="logo-wrapper">
               <img class="logo-image" :src="this.GALLERY_HOST + '/' + zone3.val" :style="getImageStyle(zone3)">
            </div>
         </div>

      </div>
   </div>  
</div>
</template>

<script>
import BasePreview from './../BasePreview';

export default {
   extends: BasePreview,

   data() {
      return {
         zone1: {},
         zone2: {},
         zone3: {}
      }
   },

   created() {
      this.assignZones();
   },

   methods: {

      assignZones() {
         this.zone1   = this.getAsset('media', 1000);
         this.zone2   = this.getAsset('text', 2000);
         this.zone3   = this.getAsset('media', 3000);
      },
   }
}
</script>

<style lang="scss" scoped>
$width: 4800px;
$height: 1200px;

$body-bg: #000;

*:focus {
  outline: none;
}


#template_72 {
   width: $width;
   height: $height;
   background: $body-bg;
   color: #fff;
   line-height: 1.5;
   font-size: 3rem;
   transform: scale(.3);
   transform-origin: left;
   position: absolute;
   left: 13%;
   // overflow: hidden;
}

#main-container {
   position: relative;
   width: 100%;
   height: 100%;
}

#main-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: flext-start;
	overflow: hidden;
	&.fade-out{
		animation: fadeOut 1.5s ease-in forwards;
	}
}

// Flex basis (width) is in each container below 
#video-container, #text-container, #branding-container {
	height: 100%;
	max-height: 100%;
}

.video-wrapper, #branding-container {
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
}

#video-container {
	flex: 0 0 1920px;
	position: relative;
	.video-wrapper {
		height: 100%;;
	}
}
#text-container {
	flex: 0 0 960px;
	animation: fadeIn 2s ease-out;
	
	.text-wrapper {
		padding: 1.5rem 1rem 1.5rem 1.5rem;
   }
   .description span {
      white-space: pre-wrap;
   }
	.description, .credit {
		font-size: 1.15rem;
	}
}

#branding-container {
	flex: 0 0 1920px;
	.logo-wrapper {
      width: 1536px;
      height: 800px;
      padding: 0 3rem;
      position: relative;
      overflow: hidden;
      
      .logo-image {
         position: absolute;
         max-width: unset;
      }
	}
}

video {
	width: auto;
	max-width: 100%;
  height: 100%;
	max-height: 100%;
	margin: 0 auto;
	object-fit: contain;
}

// Animations
@keyframes fadeIn {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
@keyframes fadeOut {
	0% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
</style>